<script lang="ts">
    /**
 *
 *
 *
 */
    import { injectWiring } from '@tilelist/application/wiring/TileListWiringContext.svelte.ts';

    interface SponsoredHintData {
        advertiserLegalName: string;
        funderLegalName: string;
    }

    const wiring = injectWiring(['trackingService']);

    let data = $state<SponsoredHintData | null>(null);

    function isSponsoredHintData(value: unknown): value is SponsoredHintData {
        return (
            value !== null && typeof value === 'object' && 'advertiserLegalName' in value && 'funderLegalName' in value
        );
    }

    function handleSheetBeforeOpen(event: CustomEvent) {
        const extraData = event.detail.extraData;
        data = isSponsoredHintData(extraData) ? extraData : null;
    }

    function handleSheetAfterClose() {
        data = null;
    }
</script>

<oc-sheet-v1
    id="reptile-sponsored-product-sheet"
    headline="Warum sehe ich diese Fläche?"
    onoc-sheet-before-open={handleSheetBeforeOpen}
    onoc-sheet-after-close={handleSheetAfterClose}
    onoc-sheet-open={() => wiring.trackingService?.trackListLayer('sponsored product')}
>
    <p class="oc-copy-100">
        Hier handelt es sich um eine gesponserte Fläche. Das sind Werbeanzeigen, die von unseren Lieferanten und
        Händlern finanziert werden.
    </p>
    <p class="oc-copy-100">Wir achten darauf, dass diese Anzeigen zu deinem Interesse bzw. deiner Suche passen.</p>
    <h1 class="oc-headline-100 oc-mt-150 oc-mb-50">Über den Werbetreibenden</h1>
    <ul class="oc-list--unordered">
        <li class="oc-mb-25">
            <span class="oc-headline-50">Name des Werbetreibenden:</span>
            {data?.advertiserLegalName}
        </li>
        <li>
            <span class="oc-headline-50">Wer hat für diese Anzeige bezahlt:</span>
            {data?.funderLegalName}
        </li>
    </ul>
</oc-sheet-v1>
